import React from 'react';
import { useOrderingContext } from '../../OrderedList';
import {
  closestCenter,
  DndContext, DragEndEvent,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors
} from '@dnd-kit/core';
import { OrderingWrapperProps } from '../types';
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';

export default function OrderingWrapperWeb(props: OrderingWrapperProps) {
  const ordering = useOrderingContext();
  const sensors = useSensors(
    useSensor(MouseSensor, {
      activationConstraint: {
        delay: 100,
        tolerance: 200,
      },
    }),
    useSensor(TouchSensor),
  );

  if (props.items.length > 1) {
    return (
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={async (event: DragEndEvent) => {
          const {
            active,
            over,
          } = event;

          if (over?.id && active.id !== over?.id) {
            const ids = props.items.map((item) => item.id);

            const oldIndex = ids.indexOf(active.id as number);
            const newIndex = ids.indexOf(over.id as number);

            const newSort = arrayMove(ids, oldIndex, newIndex);
            await ordering.updateOrderFunc(newSort);
          }
        }}
      >
        <SortableContext items={props.items} strategy={verticalListSortingStrategy}>
          {props.children}
        </SortableContext>
      </DndContext>
    );
  } else {
    return (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {props.children}
      </>
    );
  }
}
